import React, { Component } from "react";
import { Link } from "react-router-dom";

import { get } from "../../api";
import { emit } from "../../events";
import capitalize from "../../capitalize";

import CategoryDetails from "./CategoryDetails";
import AddCategory from "./AddCategory";

import "./Categories.css";

class Categories extends Component {
  state = {};

  componentDidMount() {
    this.fetchCategories();
    if (this.props.match.params.id) {
      this.fetchCategory(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match.params.id;
    if (id !== prevProps.match.params.id) {
      if (id === undefined) {
        this.setState({ category: null });
      } else {
        this.fetchCategory(id);
      }
    }
  }

  fetchCategories = async () => {
    try {
      const categories = await get("/categories");
      this.setState({ categories });
    } catch (err) {
      alert(err.message);
    }
  };

  fetchCategory = async id => {
    try {
      const category = await get("/categories/" + id);
      this.setState({ category });
    } catch (err) {
      alert(err.message);
    }
  };

  onCategoryAdded = category => {
    const { categories = [] } = this.state;
    this.setState({
      categories: categories.concat(category)
    });
    this.closeModal();
    emit("snackbar", "Category added!");
  };

  onCategoryEdited = category => {
    const { categories = [] } = this.state;
    this.setState({
      categories: categories.map(cat => {
        return cat.id === category.id ? category : cat;
      })
    });
    this.closeModal();
    emit("snackbar", "Category updated!");
  };

  onCategoryDeleted = category => {
    const { categories = [] } = this.state;
    this.setState({
      categories: categories.filter(cat => cat.id !== category.id)
    });
    this.closeModal();
    emit("snackbar", "Category deleted!");
  };

  getGroupedCategories = categories => {
    let groupedCategories = {
      letters: []
    };
    categories.forEach(category => {
      var firstLetter = category.name.substring(0, 1);
      let categoriesInGroup = groupedCategories[firstLetter];
      if (!categoriesInGroup) {
        groupedCategories.letters.push(firstLetter);
        categoriesInGroup = [];
        groupedCategories[firstLetter] = categoriesInGroup;
      }
      categoriesInGroup.push(category);
    });
    return groupedCategories;
  };

  closeModal = () => {
    this.props.history.replace("/categories");
  };

  render() {
    const { categories = [], category } = this.state;

    const groupedCategories = this.getGroupedCategories(categories);

    return (
      <div className="Categories">
        {groupedCategories.letters.map(letter => {
          const categories = groupedCategories[letter];
          return (
            <div key={letter}>
              <h2>{letter.toUpperCase()}</h2>
              <ul>
                {categories.map(category => (
                  <li key={category.id}>
                    <Link to={`/categories/${category.id}`}>
                      {category.inactive ? (
                        <strike>{capitalize(category.name)}</strike>
                      ) : (
                        capitalize(category.name)
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
        {category && (
          <CategoryDetails
            category={category}
            onEdited={this.onCategoryEdited}
            onDeleted={this.onCategoryDeleted}
            onClose={this.closeModal}
          />
        )}
        {this.props.add && (
          <AddCategory
            onAdded={this.onCategoryAdded}
            onClose={this.closeModal}
          />
        )}
      </div>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/components/Categories/Categories.js